module.exports = __webpack_public_path__ + "6c13-1658.png";